import { FetchParams, Middleware, RequestContext, ResponseContext } from '@/api/generated'
import { TokenHolder } from '@/shared/utils/token-holder'
import { Injector } from '@/config/dependency-injection'
import { loggerFor } from '@/shared/utils/logger'
import { AuthenticationService } from '@/authentication/authentication-service'

export class AuthenticationMiddleware implements Middleware {
  private logger = loggerFor('AuthenticationMiddleware')
  private tokenHolder: TokenHolder = Injector.get(TokenHolder)

  public async pre(context: RequestContext): Promise<FetchParams | void> {
    this.tokenHolder.ifPresent(token => {
      context.init.headers = {
        ...context.init.headers,
        Authorization: 'Bearer ' + token,
      }
    })

    return context
  }

  public async post(context: ResponseContext): Promise<Response | void> {
    const authToken = context.response.headers.get('Auth-Token')

    if (authToken != null) {
      this.logger.debug('Found access token in response, saving to storage')

      this.tokenHolder.set(authToken)
    }

    if (context.response.status === 401) {
      const authenticationService = Injector.get(AuthenticationService)

      authenticationService.clearAuthentication({
        goHome: false,
      })
    }

    return context.response
  }
}
